import benefits from "../../images/plataforma/back-descubrir-beneficios.jpg";

import "./Descubri.css";

export const Descubrí = (props) => {
  return (
    <div id="descubri">
      <div className="descubri-box">
        <div className="image-container">
          <p className="text-overlay">
            Descubrí los <br />
            beneficios <br />
            de Ellie Care
          </p>
          <img
            src={benefits}
            alt="Young Old Lady"
            style={{ width: "100%", margin: "0 auto" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Descubrí;
